/**
 * @ngdoc object
 * @name toolbox
 * @description
 *
 */
angular
    .module('festzelt-os.toolbox', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./toolbox-routes');

// Controllers
require('./controllers/toolbox-controller');

// Filters
require('./filters/holder-to-value-filter');
require('./filters/humanize-filter');
require('./filters/operator-to-string-filter');



// WEBPACK FOOTER //
// ./src/app/pages/toolbox/toolbox-module.js